import { Button, Tooltip } from 'antd';
import React, { memo, useMemo } from 'react';
import { ScheduleTwoTone } from '@ant-design/icons';
import DataGrid, { DataGridColDef } from 'components/DataGrid/DataGrid';
import { FinAssetDeprContextResponse } from '../../../../services/finassets';
import { toCurrency } from '../../../../utils/utils';

type DeprecationTableProps = {
  onOpenSchedule: (deprecation: FinAssetDeprContextResponse) => void;
  deprecations?: FinAssetDeprContextResponse[];
  currcode?: string;
};

const DeprecationTable = (props: DeprecationTableProps) => {
  const { onOpenSchedule, deprecations, currcode } = props;

  const columns = useMemo<DataGridColDef<FinAssetDeprContextResponse>[]>(
    () => [
      {
        comcode: 'deprcontext.contextlabel',
        dataIndex: 'contextlabel',
        width: 120,
        fixed: 'left',
      },
      {
        comcode: 'deprcontext.methodlabel',
        dataIndex: 'methodlabel',
        width: 120,
        align: 'left',
      },
      {
        comcode: 'deprcontext.complabel',
        dataIndex: 'complabel',
        width: 150,
        align: 'left',
      },
      {
        comcode: 'deprcontext.durationmonths',
        dataIndex: 'durationmonths',
        width: 100,
        align: 'left',
      },
      {
        comcode: 'deprcontext.startdate',
        dataIndex: 'startdate',
        width: 100,
        align: 'left',
      },
      {
        comcode: 'deprcontext.enddate',
        dataIndex: 'enddate',
        width: 100,
        align: 'left',
      },
      {
        comcode: 'deprcontext.coefficient',
        dataIndex: 'coefficient',
        width: 80,
        align: 'left',
      },
      {
        comcode: 'deprcontext.assetnetamount',
        dataIndex: 'assetnetamount',
        width: 150,
        align: 'left',
        render: (value, record) => toCurrency(value, currcode),
      },
      {
        comcode: 'deprcontext.compexcludedamount',
        dataIndex: 'compexcludedamount',
        width: 120,
        align: 'left',
        render: (compexcludedamount, record) => (
          <Tooltip
            title={
              `Type : ${record.comptypeexcluded ?? 'All included'} - ` +
              `Cat : ${record.compcatexcluded ?? 'All included'}`
            }
          >
            {toCurrency(compexcludedamount, currcode)}
          </Tooltip>
        ),
      },
      {
        comcode: 'deprcontext.assetrvamount',
        dataIndex: 'assetrvamount',
        width: 150,
        align: 'left',
        render: (value, record) => toCurrency(value, currcode),
      },
      {
        comcode: 'deprcontext.basisamount',
        dataIndex: 'basisamount',
        width: 150,
        align: 'left',
        render: (value, record) => toCurrency(value, currcode),
        fixed: 'right',
      },
      {
        title: 'Actions',
        key: 'actions',
        render: (text, record) => (
          <Button
            icon={<ScheduleTwoTone twoToneColor="#eb2f96" />}
            onClick={() => {
              onOpenSchedule(record);
            }}
          />
        ),
        fixed: 'right',
        width: 80,
      },
    ],
    [onOpenSchedule, currcode]
  );

  return (
    <DataGrid
      dataSource={deprecations}
      columns={columns}
      rowKey={(record) => record.contextid}
    />
  );
};

export default memo(DeprecationTable);
